<button
  type="button"
  class="spec-filter-backdrop"
  *ngIf="dockToWindow && !previewMode"
  (click)="close()"
  [attr.aria-label]="'CFproduct.closeSpecificationFilter' | translate"></button>

<div
  class="spec-filter-shell"
  [class.spec-filter-shell--window-dock]="dockToWindow && !previewMode"
  [class.spec-filter-shell--nav-linked]="navLinked"
  [class.spec-filter-shell--preview]="previewMode"
  role="region"
  [attr.aria-label]="'CFproduct.filtersHeading' | translate">
  <div class="spec-filter-sheet-handle spec-filter-mobile-only" aria-hidden="true"></div>

  <header class="spec-filter-header">
    <h2 class="spec-filter-title">{{ 'CFproduct.filtersHeading' | translate }}</h2>
    <div class="spec-filter-header__actions">
      <button type="button" class="spec-filter-reset-link" (click)="resetFilters()">
        {{ 'CFproduct.resetFilter' | translate }}
      </button>
      <button
        *ngIf="!previewMode"
        type="button"
        class="spec-filter-close"
        (click)="close()"
        [attr.aria-label]="'CFproduct.closeSpecificationFilter' | translate">
        <i-feather name="x"></i-feather>
      </button>
    </div>
  </header>

  <div class="spec-filter-search-row spec-filter-mobile-only">
    <div class="spec-filter-search-field">
      <app-search-bar
        variant="inline"
        [iconLeading]="true"
        [expandable]="false"
        [placeholderKey]="'CFproduct.searchProductByName'"
        [initialValue]="mobileSearchDraft"
        [debounceMs]="300"
        (search)="onMobileSearchDraft($event)">
      </app-search-bar>
    </div>
    <button
      type="button"
      class="spec-filter-search-submit"
      [attr.aria-label]="'Search' | translate"
      (click)="submitMobileSearch()">
      <i-feather name="search"></i-feather>
    </button>
  </div>

  <div
    class="spec-filter-applied-chips spec-filter-mobile-only"
    *ngIf="appliedFilterChips.length">
    <div class="cf-filter-chip" *ngFor="let chip of appliedFilterChips; trackBy: trackAppliedFilterChip">
      <span class="cf-filter-chip__label">{{ chip.label }}</span>
      <button
        type="button"
        class="cf-filter-chip__remove"
        [attr.aria-label]="'CFproduct.resetFilter' | translate"
        (click)="removeAppliedFilterChip(chip, $event)">
        <i-feather class="cf-filter-chip__remove-icon" name="x"></i-feather>
      </button>
    </div>
  </div>

  <div class="spec-filter-scroll">
    <details
      *ngIf="isMobileSheet && !previewMode"
      class="spec-filter-card spec-filter-card--filter-by"
      open>
      <summary class="spec-filter-card__summary">
        <span class="spec-filter-card__title">{{ 'CFproduct.filterBy' | translate }}</span>
        <i-feather name="chevron-down" class="spec-filter-card__chevron" aria-hidden="true"></i-feather>
      </summary>
      <div class="spec-filter-card__content spec-filter-by-mobile">
        <div class="spec-filter-by-toggle" role="group" [attr.aria-label]="'CFproduct.filterBy' | translate">
          <button
            type="button"
            class="spec-filter-by-pill"
            [class.spec-filter-by-pill--active]="mobileFilterMode === 'all'"
            (click)="onMobileFilterModeChange('all')">
            {{ 'CFproduct.filterAll' | translate }}
          </button>
          <button
            type="button"
            class="spec-filter-by-pill"
            [class.spec-filter-by-pill--active]="mobileFilterMode === 'order'"
            (click)="onMobileFilterModeChange('order')">
            {{ 'CFproduct.filterType' | translate }}
          </button>
        </div>
        <app-custom-select
          class="spec-filter-by-select"
          [options]="mobileSortOptions"
          [selectedValue]="mobileSortValue"
          [placeholder]="'CFproduct.selectSort' | translate"
          [disabled]="!mobileTypeSelectEnabled"
          [showAllOption]="false"
          [labelsAlreadyTranslated]="true"
          panelLayout="inline"
          (selectedValueChange)="onMobileSortChange($event)">
        </app-custom-select>
      </div>
    </details>

    <details *ngIf="showPriceRangeSection" class="spec-filter-card" [open]="accordionDefaultOpen">
      <summary class="spec-filter-card__summary">
        <span class="spec-filter-card__title">{{ 'CFproduct.priceRange' | translate }}</span>
        <i-feather name="chevron-down" class="spec-filter-card__chevron" aria-hidden="true"></i-feather>
      </summary>
      <div class="spec-filter-card__content">
        <div class="spec-price-range-shell">
          <div class="spec-price-range">
            <div class="spec-price-range__track" [style.background]="priceTrackGradient()"></div>
            <input
              class="spec-price-range__input spec-price-range__input--low"
              type="range"
              [min]="0"
              [max]="absolutePriceMax"
              [step]="1"
              [ngModel]="priceLow"
              (ngModelChange)="onPriceLowInput($event)"
              [attr.aria-valuetext]="formatPriceLabel(priceLow)" />
            <input
              class="spec-price-range__input spec-price-range__input--high"
              type="range"
              [min]="0"
              [max]="absolutePriceMax"
              [step]="1"
              [ngModel]="priceHigh"
              (ngModelChange)="onPriceHighInput($event)"
              [attr.aria-valuetext]="formatPriceLabel(priceHigh)" />
          </div>
          <div class="spec-price-inputs">
            <label class="spec-price-field">
              <span class="spec-price-field__input-wrap">
                <span class="spec-price-field__label">{{ 'CFproduct.priceMinLabel' | translate }}</span>
                <span class="spec-price-field__value">
                  <span class="spec-price-field__prefix" aria-hidden="true">$</span>
                  <input
                    class="spec-price-field__input"
                    type="number"
                    [min]="0"
                    [max]="absolutePriceMax"
                    [step]="1"
                    [ngModel]="priceLow"
                    (ngModelChange)="onPriceLowInput($event)"
                    [attr.aria-label]="'CFproduct.priceMinLabel' | translate" />
                </span>
              </span>
            </label>
            <span class="spec-price-inputs__sep">{{ 'CFproduct.priceTo' | translate }}</span>
            <label class="spec-price-field">
              <span class="spec-price-field__input-wrap">
                <span class="spec-price-field__label">{{ 'CFproduct.priceMaxLabel' | translate }}</span>
                <span class="spec-price-field__value">
                  <span class="spec-price-field__prefix" aria-hidden="true">$</span>
                  <input
                    class="spec-price-field__input"
                    type="number"
                    [min]="0"
                    [max]="absolutePriceMax"
                    [step]="1"
                    [ngModel]="priceHigh"
                    (ngModelChange)="onPriceHighInput($event)"
                    [attr.aria-label]="'CFproduct.priceMaxLabel' | translate" />
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </details>

    <details *ngIf="showPriceRangeSection" class="spec-filter-card" [open]="accordionDefaultOpen">
      <summary class="spec-filter-card__summary">
        <span class="spec-filter-card__title">{{ 'CFproduct.quickSelect' | translate }}</span>
        <i-feather name="chevron-down" class="spec-filter-card__chevron" aria-hidden="true"></i-feather>
      </summary>
      <div class="spec-filter-card__content">
        <div class="spec-quick-grid">
          <button
            type="button"
            class="spec-quick-btn"
            *ngFor="let slot of quickSlots"
            [class.spec-quick-btn--active]="activeQuickSlot === slot"
            (click)="applyQuickSlot(slot)">
            {{ quickSlotLabel(slot) }}
          </button>
        </div>
      </div>
    </details>

    <ng-container *ngIf="showFilterSection && !loading && !loadError">
      <details
        class="spec-filter-card"
        *ngFor="let group of specGroups; trackBy: trackByGroupId"
        [open]="accordionDefaultOpen"
        [attr.aria-label]="specificationSetName(group)">
        <summary class="spec-filter-card__summary">
          <span class="spec-filter-card__title">{{ specificationSetName(group) }}</span>
          <i-feather name="chevron-down" class="spec-filter-card__chevron" aria-hidden="true"></i-feather>
        </summary>
        <div class="spec-filter-card__content">
          <ul class="spec-filter-group__list">
            <li
              class="spec-filter-spec-block"
              *ngFor="let spec of sortedSpecifications(group); trackBy: trackByItemSpec">
              <div
                class="spec-filter-spec-block__name"
                *ngIf="hasFilterableSpec(spec) && showSpecBlockName(group)">
                {{ specificationDisplayName(spec) }}
              </div>
              <ul class="spec-filter-value-list" *ngIf="hasFilterableSpec(spec)">
                <li *ngFor="let line of distinctLineValues(spec); trackBy: trackByLineIndex">
                  <label class="spec-check" *ngIf="specValueToken(spec, line)">
                    <input
                      type="checkbox"
                      class="spec-check__input"
                      [checked]="isSpecValueSelected(spec, line)"
                      (change)="toggleSpecValue(spec, line, $any($event.target).checked)" />
                    <span class="spec-check__box" aria-hidden="true"></span>
                    <span class="spec-check__label">{{ lineValueLabel(line) }}</span>
                    <span
                      class="spec-check__count"
                      *ngIf="lineValueCount(line) !== null"
                      [class.spec-check__count--active]="isSpecValueSelected(spec, line)">
                      {{ lineValueCount(line) }}
                    </span>
                  </label>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </details>
    </ng-container>

    <p class="spec-filter-status" *ngIf="showFilterSection && loading">{{ 'CFproduct.specFiltersLoading' | translate }}</p>
    <p class="spec-filter-status spec-filter-status--error" *ngIf="showFilterSection && loadError && !loading">
      {{ 'CFproduct.specFiltersLoadError' | translate }}
    </p>
  </div>

  <footer class="spec-filter-footer spec-filter-mobile-only">
    <button type="button" class="spec-filter-apply-btn" (click)="applyMobileFilters()">
      {{ 'CFproduct.showResults' | translate: { count: mobileResultCount } }}
    </button>
  </footer>
</div>
